import { forwardRef } from 'react';
import MaterialButtonGroup, {
    ButtonGroupProps,
} from '@mui/material/ButtonGroup';

export const ButtonGroup = forwardRef<HTMLDivElement, ButtonGroupProps>(
    (props, ref) => {
        return (
            <MaterialButtonGroup
                ref={ref}
                data-testid={'ButtonGroup-container'}
                {...props}
            />
        );
    }
);

export default ButtonGroup;
